import type { BaseFile } from 'config'

export interface ITicket {
  id: number
  title: string
  description: string
  loanNumber?: number
  userInfo?: any
  status: TicketStatus
  hasUncheckedMessages: boolean
  hasUncheckedAdminMessages: boolean
  dueDate: string
  createdAt: string
  updatedAt: string
  project: IProject
  asanaTicket?: string
  customFields?: Record<string, any>
}

export interface IProject {
  id: number
  userId: number
  userFirstName: string
  userLastName: string
  name: string
  description: string
  status: ProjectStatus
  environments: Record<string, any>
  settings: Record<string, any>
  createdBy: string
  createdAt: string
  updatedAt: string
  logo: string
  logoURL: string
  icon: string
  iconURL: string
  company: ICompany
}

export interface ICompany {
  companyName: string
  title: string
  dns: string
  nmls: string
  phone: string
  phoneFree: string
  address: string
  companyContactEmail: string
  facebookUrl: string
  twitterUrl: string
  instagramUrl: string
  linkedinUrl: string
  youtubeUrl: string
  appleIconUrl: string
}

export enum ProjectStatus {
  Pending = 0,
  Deploying = 1,
  Deployed = 2,
  Terminating = -1,
  Inactive = -2,
  Delected = -3,
}

export enum TicketStatus {
  Requested = 0,
  InProgress = 1,
  Testing = 2,
  Completed = 3,
  Closed = -1,
}

export const TicketStatusColorMap = {
  [TicketStatus.Requested]: 'bg-indigo-400 text-white p-2 rounded-md',
  [TicketStatus.InProgress]: 'bg-yellow-400 text-white  p-2 rounded-md',
  [TicketStatus.Testing]: 'bg-blue-400 text-white  p-2 rounded-md',
  [TicketStatus.Completed]: 'bg-green-400 text-white  p-2 rounded-md',
  [TicketStatus.Closed]: 'bg-gray-500 text-white  p-2 rounded-md',
}

export const TicketStatusText: Record<TicketStatus, string> = {
  [TicketStatus.Requested]: 'Requested',
  [TicketStatus.InProgress]: 'In Progress',
  [TicketStatus.Testing]: 'Testing',
  [TicketStatus.Completed]: 'Completed',
  [TicketStatus.Closed]: 'Closed',
}

export const TicketStatusHoverColorMap = {
  [TicketStatus.Requested]: 'text-indigo-200',
  [TicketStatus.InProgress]: 'text-green-600',
  [TicketStatus.Testing]: 'text-blue-600',
  [TicketStatus.Completed]: 'text-red-500',
}

export const TicketStatusHoverBorderColorMap = {
  [TicketStatus.Requested]: 'border-indigo-200',
  [TicketStatus.InProgress]: 'border-green-600',
  [TicketStatus.Testing]: 'border-blue-600',
  [TicketStatus.Completed]: 'border-red-500',
}

export const statusArr = ['Requested', 'In Progress', 'Completed', 'Closed']

export const statusMap: Record<string, TicketStatus> = {
  Requested: TicketStatus.Requested,
  'In Progress': TicketStatus.InProgress,
  Testing: TicketStatus.Testing,
  Completed: TicketStatus.Completed,
  Closed: TicketStatus.Closed,
}

export type ITicketItem = {
  id: number
  ticketId: string
  text: string
  createdBy: string
  isAdmin: boolean
  updatedAt: string
  createdAt: string
  files: BaseFile[]
}

export type IAsanaTicketItem = {
  created_at: string
  created_by: any
  gid: string
  resource_subtype: string
  resource_type: string
  text?: string
  html_text?: string
  type: string
  downloaded_url?: string
  file_name?: string
  attachment_gid?: string
}

export type ITicketDetailsItem = {
  created_at: string
  custom_fields: any[]
  gid: string
  name: string
  notes: string
  html_notes?: string
}

export type IAsanaAttachment = {
  gid: string
  name: string
  download_url: string
}
